<template>
  <main>
    <v-container>
      <v-row>
        <v-col cols="3">
          <v-menu
            bottom
            right
            allow-overflow
            offset-y
            nudge-bottom="20"
            nudge-width="300"
            max-height="400"
            transition="slide-y-transition"
            :close-on-content-click="false"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="primary" depressed disabled v-bind="attrs" v-on="on">
                <v-icon>filter_alt</v-icon>
                <span>Filters</span>
              </v-btn>
            </template>
          </v-menu>
        </v-col>
        <v-col cols="3" class="ml-auto">
          <search-input v-model="search" hide-details />
        </v-col>
      </v-row>
    </v-container>
    <v-container>
      <v-row>
        <v-col>
          <v-card outlined :disabled="loading" :loading="loading">
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">Logo</th>
                    <th class="text-left">Name</th>
                    <th class="text-left">Symbol</th>
                    <th class="text-left">Start date</th>
                    <th class="text-left">End date</th>
                    <th class="text-right">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="resource in resources.data" :key="resource.id">
                    <td>
                      <v-avatar size="30">
                        <img :src="`https://storage.googleapis.com/contzilla/${resource.logo}`" alt="John" />
                      </v-avatar>
                    </td>
                    <td>{{ resource.name }}</td>
                    <td>{{ resource.symbol }}</td>
                    <td>{{ resource.ico_opening_date | formatDate }}</td>
                    <td>{{ resource.ico_closing_date | formatDate }}</td>
                    <td class="text-right">
                      <router-link class="no-underline" :to="redirectToView(resource.id)">
                        <v-btn icon text>
                          <v-icon>remove_red_eye</v-icon>
                        </v-btn>
                      </router-link>

                      <router-link
                        v-if="isPermittedTo('update')"
                        class="no-underline"
                        :to="redirectToEditView(resource.id)"
                      >
                        <v-btn icon text>
                          <v-icon>create</v-icon>
                        </v-btn>
                      </router-link>
                      <v-btn
                        v-if="isPermittedTo('delete')"
                        :loading="checkResourceIsDeleting(resource.id)"
                        icon
                        text
                        @click="showDeleteModal(resource.id)"
                      >
                        <v-icon>delete</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <v-container>
      <v-col>
        <v-row>
          <v-pagination
            v-model="page"
            :length="Math.ceil(resources.pagination.total / resources.pagination.perPage)"
            @input="getResources"
          />
        </v-row>
      </v-col>
    </v-container>
    <delete-modal
      v-if="deleteModalVisible"
      v-model="deleteModalVisible"
      :is-disabled="isDeleting"
      :is-loading="isDeleting"
      :item="deletingResource"
      :category="resourceType"
      @modal-confirm="onResourceDeleteConfirmed"
      @modal-cancel="onResourceDeleteCancelled"
    />
    <fab-create v-if="isPermittedTo('create')" :type="resourceType" @click="redirectToCreateView" />
  </main>
</template>

<script>
import moment from 'moment'
import { mapGetters, mapActions } from 'vuex'

import PermissionsHandler from '@/mixins/permissions-handler'
import ListResource from '@/mixins/list-resource'
import DeleteResource from '@/mixins/delete-resource'

export default {
  name: 'IcosIndex',
  filters: {
    formatDate(date) {
      return date ? moment(date).format('MMMM Do YYYY, h:mm:ss') : 'To be announced'
    },
  },
  mixins: [PermissionsHandler, ListResource, DeleteResource],
  data() {
    return {
      resourceType: 'Ico',
      resourcePrefix: 'content.icos',
      resourceKey: 'name',
    }
  },
  computed: {
    ...mapGetters({
      resources: 'icos/getIcos',
    }),
  },
  methods: {
    ...mapActions({
      fetchResources: 'icos/fetch',
      deleteResource: 'icos/delete',
    }),
  },
}
</script>
